/**
 * @Author: 左建
 * @Date: 2022/9/14 19:50
 * @LastEditors: 左建
 * @LastEditTime: 2022/9/14 19:50
 * @Description: 我的课程一些配置
*/

export const TABS_LIST = Object.freeze([
    {
        label: "已学习",
        value: "2",
        enName: "studied"
    },
    {
        label: "待学习",
        value: "1",
        enName: "study"
    },
])
// 获取初始化课程列表
export function getInitCourseList() {
    return TABS_LIST.reduce((preVal, curVal) => {
        preVal[curVal.value] = []
        return preVal
    }, {})
}

// 获取初始化pagination
export function getInitPagination(mergeObj) {
    return TABS_LIST.reduce((preVal, curVal) => {
        const pagination = {
            pageIndex: 1,
            pageSize: 10,
            total: 10
        }
        preVal[curVal.value] = Object.isObj(mergeObj) ? Object.assign(pagination, mergeObj) : pagination
        return preVal
    }, {})
}
